<div class="main">
  <span class="mat-caption">{{ labelValue | locLabel | capitalize }}</span>
  <p class="mat-subheading-2">
    <strong>
      <ng-content></ng-content>
    </strong>
  </p>
</div>
